import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import arrowDownIcon from '../../../assets/icons/icon_arrow-down-blue.svg';
import searchIcon from '../../../assets/icons/icon_search.svg';

import { CaseFilter, SearchModal } from './SearchModal';

const FlexForm = styled.form`
  display: flex;
  width: 570px;
  max-width: 100%;
`;

const SearchBar = styled.input`
  flex-grow: 1;
  height: 52px;
  box-sizing: border-box;
  padding: 11px 26px 11px 26px;
  border: 1px solid #e6e6e6;
  border-radius: 5px 0px 0px 5px;
  overflow: auto;
`;

const SearchBarButton = styled.button<{
  $borderRadius?: string;
  $backgroundImage: string;
}>`
  flex-shrink: 0;
  width: 60px;
  height: 52px;

  background-color: var(--HPACS_BG_grey, #f5f5f5);
  background-image: url(${p => p.$backgroundImage});
  background-size: 16px 16px;
  background-position: 50%;
  background-repeat: no-repeat;
  border: 1px solid #e6e6e6;
  border-radius: ${p => p.$borderRadius ?? 0};
  cursor: pointer;
`;

interface FilterSearchBarProps {
  onSearch: (filter: CaseFilter | undefined) => void;
}
export const FilterSearchBar = (props: FilterSearchBarProps) => {
  const { onSearch } = props;

  const { t } = useTranslation();
  const [general, setGeneral] = useState<string>('');
  const [openModal, setOpenModal] = useState(false);

  const onSearchByGeneral = () => {
    if (general.length) {
      onSearch({ general: { filter: general, type: 'containsIgnoreCase' } });
    } else {
      onSearch(undefined);
    }
  };

  const searchBarRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <FlexForm
        onSubmit={e => {
          e.preventDefault();
          onSearchByGeneral();
          searchBarRef.current?.blur();
        }}>
        <SearchBar
          type="text"
          ref={searchBarRef}
          placeholder={`${t('features.imageList.myImageList.searchBar')}`}
          value={general}
          onChange={e => setGeneral(e.target.value)}
        />
        <SearchBarButton $backgroundImage={searchIcon} />
        <SearchBarButton
          type="button"
          $borderRadius="0px 5px 5px 0px"
          $backgroundImage={arrowDownIcon}
          onClick={() => setOpenModal(true)}
        />
      </FlexForm>
      <SearchModal
        open={openModal}
        onClose={(searchedFilter: CaseFilter) => {
          setOpenModal(false);
          setGeneral(searchedFilter.general?.filter ?? '');
        }}
        onSearch={onSearch}
        defaultGeneralValue={general}
      />
    </>
  );
};
